<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="scroll-box">
                <v-container class="modal-container">
                    <v-row>
                        <v-col>
                            <h1>Investimento</h1>
                            <v-row v-if="loading">
                                <v-col class="justify-center align-center">
                                    <v-progress-circular :size="35"
                                                        color="primary"
                                                        indeterminate />
                                </v-col>
                            </v-row>
                            <v-row class="command-col">
                                <v-col>
                                    <!--button type="button"
                                            v-if="source.transactions && source.transactions.length"
                                            title="Selectionar todas as transações para adição ao Kristal."
                                            :disabled="loading"
                                            @click="allTrans($event)">
                                        {{ getAllLabel() }}
                                    </button-->
                                    <button type="button"
                                            title="Selecionar investimento para adição ao Kristal"
                                            :class="getSelfClass()"
                                            :disabled="loading"
                                            @click="selfStatus($event)">
                                        {{ getSelfLabel() }}
                                    </button>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>Nome: {{ source.name }}</v-col>
                                <v-col class="item-editable"
                                       title="Clique para editar o código do investimento"
                                       @click="editCode($event)">
                                    <span>Código: {{ source.code }}</span>
                                </v-col>
                                <v-col>Isin: {{ source.isin }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Status: {{ source.status_imp }}</v-col>
                                <v-col>Mensagem: {{ source.message_imp }}</v-col>
                                <v-col>Data: {{ source.date_imp }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>No.: {{ source.number }}</v-col>
                                <v-col>Propr.: {{ source.owner }}</v-col>
                                <v-col>Moeda: {{ source.currencyCode }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Tipo: {{ source.type }}</v-col>
                                <v-col>Subt.: {{ source.subtype }}</v-col>
                                <v-col>T. últ. mês: {{ percentageHelper.formatStandard(source.lastMonthRate) }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>T. anual: {{ percentageHelper.formatStandard(source.annualRate) }}</v-col>
                                <v-col>Data: {{ formatDate(source.date) }}</v-col>
                                <v-col>Valor: {{ currencyHelper.formatValue(source.value) }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Quantidade: {{ source.quantity }}</v-col>
                                <v-col>Total: {{ currencyHelper.formatValue(source.amount) }}</v-col>
                                <v-col>Taxas: {{ source.taxes }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Tx. adic.: {{ source.taxes2 }}</v-col>
                                <v-col>Saldo: {{ currencyHelper.formatValue(source.balance) }}</v-col>
                                <v-col>Vencimento: {{ formatDate(source.dueDate) }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Taxa: {{ percentageHelper.formatStandard(source.rate) }}</v-col>
                                <v-col>Tp. Taxa: {{ source.rateType }}</v-col>
                                <v-col>T. fix. anual: {{ percentageHelper.formatStandard(source.fixedAnnualRate) }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Emissor: {{ source.issuer }}</v-col>
                                <v-col>Emissão: {{ formatDate(source.issueDate) }}</v-col>
                                <v-col>Lucro: {{ source.amountProfit }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Saque: {{ currencyHelper.formatValue(source.amountWithdrawal) }}</v-col>
                                <v-col>Original: {{ source.amountOriginal }}</v-col>
                                <v-col>Status: {{ source.status }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Nome b.: {{ source.institution && source.institution.name }}</v-col>
                                <v-col>No. b.: {{ source.institution && source.institution.number }}</v-col>
                                <v-col>&nbsp;</v-col>
                            </v-row>
                            <v-row class="data-table">
                                <v-col>
                                    <table v-if="source.transactions && source.transactions.length">
                                        <caption>Transações</caption>
                                        <thead>
                                            <tr>
                                                <th>Negociação</th>
                                                <th>Data</th>
                                                <th>Total</th>
                                                <th>Tipo</th>
                                                <th>Marcada?</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="transaction in source.transactions"
                                                :key="transaction.transactionId"
                                                @click="viewTransaction(transaction)">
                                                <td>{{ formatDateAbbr(transaction.tradeDate) }}</td>
                                                <td>{{ formatDateAbbr(transaction.date) }}</td>
                                                <td>{{ currencyHelper.formatValue(transaction.amount) }}</td>
                                                <td>{{ transaction.type }}</td>
                                                <td>
                                                    <input type="checkbox"
                                                            title="Status de seleção para adição ao Kristal"
                                                            :checked="transaction.import ? 'checked' : ''"
                                                            :disabled="loading"
                                                            @click="tgStatus($event, transaction)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <v-btn icon
            class="close-btn"
            :disabled="loading"
            @click="$emit('close')">
            <img src="@/assets/icons/close.svg"
                alt="dashboard"
                class="icon" />
        </v-btn>

        <TransactionDetails v-if="displaying"
                            @close="displaying = false"
                            :source="target" />
    </div>
</template>

<style scoped>
.close-btn {
  position: fixed;
  top: 6%;
  right: 6%;
}
.modal-mask {
  position: fixed;
  z-index: 21;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0px auto;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-wrapper > .scroll-box {
  max-width: 90% !important;
  width: 90% !important;
  max-height: 90% !important;
  height: 90% !important;
  margin: auto;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
}
.modal-container .row .col table {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
    font-size: 0.8rem;
}
.modal-container .row .col table caption {
    font-weight: bold;
    font-size: 1.5rem;;
}
.modal-container .row .col table thead tr th,
.modal-container .row .col table tbody tr td {
    padding: 0.25rem;
    cursor: pointer;
    width: 20%;
    text-align: center;
}
.modal-container .row .col table thead tr th {
    background-color: black;
    color: white;
}
.modal-container .row .col table tbody tr:nth-child(odd) {
    background-color: #DDDDDD;
}
.modal-container .row .col .row .col {
    height: 1.8rem;
}
.modal-container .row .col .row.command-col .col {
    height: 4.5rem;
    min-height: 4.5rem;
    border-bottom: 2px solid rgba(0, 128, 0, .75);;
}
.modal-container .row .col .row.data-table .col {
    margin-top: 1rem;
    height: unset;
    min-height: fit-content;
    border-top: 2px solid rgba(0, 128, 0, .75);;
}
.modal-container .row .col button {
    background-color: rgba(0, 32, 32, .5);
    color: white;
    border-radius: 20px;
    padding: 0.7rem;
    margin: 0;
}
@media screen and (max-width: 1024px) {
    .close-btn {
        top: 1%;
        right: 6%;
    }
    .modal-container .row {
        flex-direction: column;
    }
    .modal-container .row .col .row .col {
        font-size: 0.75rem;
        height: unset;
        min-height: 1.8rem;
    }
    .modal-container .row .col button {
        padding: 0.35rem;
    }
    .modal-wrapper > .scroll-box {
        max-height: unset;
        height: unset;
        min-width: 100% !important;
        max-width: unset;
        width: unset;
        min-height: fit-content;
    }
    .modal-wrapper {
        display: block;
        height: 100%;
        width: 100%;
        overflow: scroll;
    }
}
.modal-container .row .col .row .col.item-editable span {
    background-color: #DDDDDD;
    border-radius: 4px;
    padding: 6px;
    margin: -6px;
    cursor: pointer;
}
</style>

<script lang="js">
import ApiService from '../../../../../services/ApiService';
import EventBus from '../../../../Bus/bus';
import currencyHelper from '../../../../../Utils/CurrencyHelper';
import percentageHelper from '../../../../../Utils/PercentageHelper';
import TransactionDetails from './TransactionDetails.vue';

export default          {
    props               : {
        source          : { type: Object }
    },
    data                () {
        return {
            currencyHelper,
            percentageHelper,
            apiService  : undefined,
            loading     : false,
            displaying  : false,
            target      : undefined
        };
    },
    components          : { TransactionDetails },
    methods             : {
        formatDate      (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
        },
        formatDateAbbr  (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return dt.toLocaleDateString();
        },
        viewTransaction (trans) {
            if (this.loading || !trans) { return; }
            this.displaying = true;
            this.target     = trans;
        },
        getAllLabel     () {
            const chk = this.source &&
                        this.source.transactions &&
                        this.source.transactions.length &&
                        this.source.transactions.every((t) => t.import);
            return chk ? 'Desmarcar todas as transações' : 'Selecionar todas as transações para adição ao Kristal';
        },
        async allTrans  (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            this.loading = true;
            try {
                const part = this.source.transactions.some((t) => !t.import);
                const userId = this.$store.getters.$tokenUserSelected;
                const resp = await this.apiService.setInvestmentImportStatus(this.source, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                this.source.transactions.forEach((t) => t.import = part);
            } finally {
                this.loading = false
                return false;
            }
        },
        getSelfClass    () {
            if (!this.source) { return ''; }
            return this.source.status_imp === 'Marcado para importação.' ? 'item-checked' : 'item-unchecked';
        },
        getSelfLabel    () {
            //if (!this.source || (this.source.transactions && this.source.transactions.length)) { return ''; }
            return this.source.status_imp === 'Marcado para importação.' ? 'Limpar seleção de importação' : 'Selecionar investimento para adição ao Kristal';
        },
        async selfStatus(e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            if (this.source.transactions &&
                this.source.transactions.length &&
                !this.source.transactions.some((t) => t.import)) {
                const message = "Esse investimento possui transações mas você não marcou nenhuma. " +
                                "Marcar uma transação seleciona esse investimento automaticamente. " +
                                "Deseja marcar o investimento sem selecionar nenhuma transação?";
                if (!confirm(message)) { return; }
            }
            this.loading = true;
            const enable = this.source.status_imp === 'Marcado para importação.';
            try {
                const userId = this.$store.getters.$tokenUserSelected;
                const resp = await this.apiService.toggleTransImportStatus({
                    investmentId : this.source.investmentId,
                    transactionId: 0,
                    import       : enable
                }, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                this.source.status_imp = enable ?
                    'Não processado.' :
                    'Marcado para importação.';
                if (enable) {
                    this.source.message_imp = undefined;
                    this.source.date_imp = undefined;
                }
            } finally {
                this.loading = false
                return false;
            }
        },
        async tgStatus  (e, trans) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !trans) { return; }
            this.loading = true;
            try {
                const userId = this.$store.getters.$tokenUserSelected;
                const resp   = await this.apiService.toggleTransImportStatus(trans, userId);
                if (!resp.success) {
                    this.$toast.error(data.message);
                    return;
                }
                trans.import = !trans.import;
            } finally {
                this.loading = false
                return false;
            }
        },
        editCode        (e) {
            e.cancelBubble = true;
            const call = {
                width  : 400,
                height : 300,
                view   : 'EditarCodigoInvestimento'
            };
            EventBus.$emit('openFloatModal', call, this.source);
        }
    },
    created             () {
        this.apiService = new ApiService();
    },
    mounted             () {

    },
    beforeDestroy       () {

    }
}
</script>